import classNames from 'classnames'
import React from 'react'

import { Strong } from './strong'

export const ColourCode: React.FC<{ colour: 'red' | 'green' | 'default' }> = ({
  colour,
  children,
}) => (
  <Strong>
    <span
      className={classNames({
        'stk-text-danger': colour === 'red',
        'stk-text-success': colour === 'green',
      })}
    >
      {children}
    </span>
  </Strong>
)
